import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import TxtBtn from './TxtBtn.js';

export default class Btn extends Phaser.GameObjects.Container {
    constructor(scene, x, width, height, data) {
        super(scene, x, data.y, []);
        scene.add.existing(this);
        this.scene = scene;

        this.w = width;
        this.h = height;
        this.title = data.title;
        this.state = data.state;
        this.isMulti = data.isMulti
        this.index = data.index
        this.allTxtBtnsData = data.txtBtns
        this.data = data
        this.isDone = false;

        this.allTxtBtns = []

        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });

        this.rect = this.scene.add.rexRoundRectangle(0, 0, this.w, this.h, 15, Colors.Elmt.MainBlue).setOrigin(0);
        this.add(this.rect);
        this.strocks = this.scene.add.rexRoundRectangle(-14, -14, this.w, this.h, 15, Colors.Elmt.lightBlue, 0).setOrigin(0);
        this.strocks.setStrokeStyle(3, Colors.Elmt.Black)
        this.add(this.strocks);

        this.txt = this.scene.add.rexTagText(this.w / 2, this.h / 2, this.title, {
            fontSize: "30px",
            fontFamily: "CenturyGothic",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: this.w - 40 },
            tags: tags
        }).setOrigin(0.5, 0.5);
        this.add(this.txt);

        this.on('pointerdown', () => {
            this.clickSound.play();
            this.scene.allBtns.forEach(element => {
                if (element.isDone && element.index !== this.index) {
                    element.setDone();
                }
                if (element.state === 'opened' && element.index !== this.index) {
                    element.setClosed();
                }
            });
            // if (this.isMulti) {
            //     this.scene.allBtns.forEach(element => {
            //         console.log("close all")
            //         if (element.state === 'opened' && element.index !== this.index) {
            //             element.setClosed();
            //         }
            //     });

            // } else {
            //     this.scene.allBtns.forEach(element => {
            //         console.log("close all")
            //         if (element.state === 'opened' && element.index !== this.index) {
            //             element.setClosed();
            //         }
            //     });
            // }
        })

        this.setLocked();
    }

    setClickFunction(clickFunction) {
        this.on('pointerup', () => {
            clickFunction(this);
        }, this.scene);
    }

    setLocked() {
        if (this.isDone) {
            this.rect.setFillStyle(Colors.Elmt.SoLightOrange);

        } else {
            this.rect.setFillStyle(Colors.Elmt.lightBlue);
        }
        this.state = 'locked';
        this.disableInteractive();
    }

    setUnlocked() {
        if (this.isDone) {
            this.rect.setFillStyle(Colors.Elmt.SoLightOrange);

        } else {
            this.rect.setFillStyle(Colors.Elmt.MainBlue);
        }
        this.state = 'unlocked';
        this.setSize(this.w, this.h);
        this.setInteractive({ useHandCursor: true });
        this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
    }

    setActif() {
        this.rect.setFillStyle(Colors.Elmt.MidOrange);
        this.disableInteractive();
        this.isDone = true;
    }

    setOpened(id) {
        this.state = 'opened';
        // this.rect.setFillStyle(Colors.Elmt.MidOrange);
        // this.disableInteractive();
        this.setActif();
        this.openedTween = this.scene.tweens.add({
            targets: this.rect,
            width: 1690,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.addBtnText(this.allTxtBtnsData, this)
                if(id === 6){
                    this['txtBtn3'].setActif();
                    this['txtBtn2'].setUnlocked();
                    this['txtBtn1'].setUnlocked();
                }

            }
        })
    }

    setClosed() {
        this.allTxtBtns.forEach(btn => {
            btn.destroy();
        })
        this.allTxtBtns = []
        // this.isDone = true;
        this.state = 'unlocked';
        this.rect.setFillStyle(Colors.Elmt.SoLightOrange);
        this.scene.tweens.add({
            targets: this.rect,
            width: this.w,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.setDone()
                // let value = this.scene.allBtns.every(btn=> btn.isDone)
                // console.log("all done", value)
                // if (value) {
                //     this.scene.btn1.setLocked()
                // }
                // this.setSize(this.w, this.h);
                // this.setInteractive({ useHandCursor: true });
                // this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
            }

        })
    }
    setClosedAndDisable() {
        this.allTxtBtns.forEach(btn => {
            btn.destroy();
        })
        // this.isDone = true;
        this.state = 'unlocked';
        this.rect.setFillStyle(Colors.Elmt.SoLightOrange);
        this.scene.tweens.add({
            targets: this.rect,
            width: this.w,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.setDone()
                this.disableInteractive();
                // let value = this.scene.allBtns.every(btn=> btn.isDone)
                // console.log("all done", value)
                // if (value) {
                //     this.scene.btn1.setLocked()
                // }
                // this.setSize(this.w, this.h);
                // this.setInteractive({ useHandCursor: true });
                // this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
            }

        })
    }

    setDone() {
        this.isDone = true;
        this.rect.setFillStyle(Colors.Elmt.SoLightOrange);
        this.setSize(this.w, this.h);
        this.setInteractive({ useHandCursor: true });
        this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
    }

    addBtnText(allTxtBtns, btnParent) {
        for (let i = 0; i < allTxtBtns.length; i++) {
            const element = allTxtBtns[i];
            let btnName = 'txtBtn' + (i + 1)
            this[btnName] = new TxtBtn(this.scene, 770 + this.data.btnSpace * i, this.rect.height / 2, element, btnParent, 'unlocked', (i + 1));
            this.add(this[btnName]);
            this.allTxtBtns.push(this[btnName]);
            this[btnName].setClickFunction(() => {
                this.scene.screenMaker[element.funct]()
            })
        }
        this.txtBtn1.setUnlocked();
    }
}